import React, { useRef, useEffect, useMemo } from 'react';
import { useGLTF } from "@react-three/drei";
import useGlobal from '../store';
import { disposeMaterial } from '../scripts/helpers/create.pbr.material';
import { classifyFurnitureRole, variantFurnitureMaterial } from '../scripts/helpers/furniture.material';

const Environment = ( props ) => {

  if ( !props.model ) return null;

  return <EnvironmentModel { ...props } />;

};

const EnvironmentModel = ( props ) => {

  const { 

    id = "", 
    model = "", 
    position = "", 
    rotationY = false, 
    refDOM = false, 
    onClick = false, 
    syncTextures = () => {}

  } = props;

  const [ globalState, globalActions ] = useGlobal();
  const { constructor } = globalActions;
  
  const ref = useRef();
  //// let { scene = false } = useGLTF( model );
  const GLTF = useGLTF( model );
  const scene = useMemo(() => GLTF.scene.clone(), [ GLTF?.scene ]);

  useEffect(() => {

    if ( scene && model !== "" ) {

      refDOM.current = ({ target = false, texture, uniqName }) => {

        const meshes = [];
        scene.traverse(( o ) => { if ( o.isMesh ) meshes.push( o ); });

        meshes.forEach(( o ) => {

          o.castShadow = true;
          o.receiveShadow = true;

          if ( uniqName === id ) {

            if (
              o.material
              && o.material !== texture
              && o.material.userData?.isConstructorMaterial
            ) {

              disposeMaterial( o.material );

            }

            const role = classifyFurnitureRole( o, meshes );
            o.material = variantFurnitureMaterial( texture, role );
            o.material.needsUpdate = true;

            if ( target ) { o.nameID = target; }
                        
          }

        });
    
      }
      
      syncTextures( id ); 
      // console.log(`######  Environment syncTextures id=${ id }`);    
  
    }
    
  }, [ model ]);

  return (

    !scene ? null : 
    
    <primitive

      object = { scene || null }
      ref = { ref }
      dispose = { null }      
      castShadow 
      receiveShadow
      position = { position }
      rotation-y = { rotationY || 0 }
      onClick={( e ) => { 

        if ( scene ) {
          
          constructor.setModelRef( id, e.object.name );
          onClick && onClick();
          e.stopPropagation();
        
        } else {

          console.error(`Попытка повесить onClick на несуществующий/скрытый Environment успешно прервана`);

        }
        
      }}

    />

  );

}

export default Environment;
